import './styles/global.scss';
import '@ri-digital/web-data-layer';

import LoadingOverlay from '@ri-digital/web-component-library/src/molecule/LoadingOverlay';
import Footer from '@ri-digital/web-component-library/src/organism/Footer';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';

import style from './App.scss';
import Header from './components/Header';
import { checkPaymentIntent } from './helpers/checkPaymentIntent';
import extractDomain from './helpers/extractDomain';
import useSDKSync from './hooks/useSDKSync';
import MainLayout from './layouts/MainLayout';
import OrderConfirmationLayout from './layouts/OrderConfirmationLayout';
import { appOs, isWebview } from './lib/reactives';
import { Routes } from './routes/routes';
import getCookie from '../analytics/helpers/getCookie/getCookie';

const cx = classNames.bind(style);

const App = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const isOrderPage = searchParams.get('trackingNumber');
  const hasPaymentIntent = checkPaymentIntent(searchParams);

  useSDKSync();

  const [showWebviewUI, setShowWebViewUI] = useState(false);

  useEffect(() => {
    if (searchParams.get('webview')) {
      setShowWebViewUI(true);
      isWebview(true);
      appOs(searchParams.get('os'));

      if (Routes.localCheckout.path === pathname) {
        document.cookie = `isWebView=true;domain=${extractDomain()};path=/`;
      }
    }
  }, [searchParams, pathname]);

  const isGlobalEWebview =
    Routes.localCheckout.path === pathname && getCookie('isWebView');

  const appContent = () => {
    if (!isOrderPage) {
      return <MainLayout hasPaymentIntent={hasPaymentIntent} />;
    }
    if (!hasPaymentIntent && isOrderPage) {
      return <OrderConfirmationLayout />;
    }
    return <LoadingOverlay loading variant="inOverlay" />;
  };

  return (
    <div className={cx('app')}>
      {showWebviewUI || isGlobalEWebview ? null : <Header />}
      {appContent()}
      {showWebviewUI || isGlobalEWebview ? null : <Footer />}
    </div>
  );
};

export default App;
